import { Box } from "@mui/material"
import LoadingSpinner from "./LoadingSpinner"

const ImageLoading = ({img}) => {
    return(
        <>
           {!img && (
                            <Box
                              sx={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                background: "#fff",
                                zIndex: 1,
                              }}
                            >
                              <LoadingSpinner />
                            </Box>
                          )}
        </>
    )
}

export default ImageLoading;